import posed from 'react-pose'

export const FadingView = posed.div({
  visible: {
    opacity: 1,
    delayChildren: 200,
    staggerChildren: 50,
  },
  hidden: {
    opacity: 0,
    delay: 100,
    staggerChildren: 50,
    staggerDirection: -1,
  },
})

export const FadingViewChild = posed.div({
  visible: { y: 0, opacity: 1 },
  hidden: { y: 20, opacity: 0 },
})
